<style lang="scss" src='./Profile.scss' scoped></style>
<template src="./Profile.html"></template>

<script>
import {
  omit,
} from 'lodash';
import {
  mapState,
  mapActions,
  mapMutations,
} from 'vuex';

export default {
  name: 'UserProfile',
  data() {
    return {
      newUserPhoto: null,
    };
  },
  computed: {
    ...mapState('Settings', ['user', 'loading']),
  },
  methods: {
    ...mapActions('Settings', ['apiGetUser', 'apiGetMe', 'apiUpdateMe']),
    ...mapMutations('Settings', ['setUser', 'setLoading']),

    async onSubmit() {
      await this.apiUpdateMe(this.newUserPhoto);
      this.newUserPhoto = null;
    
      const userUpdated = {...this.$store.state.user, ...omit(this.user, ['golf_courses']) }; // Admin does not have courses thats why we can not update this
      this.$store.commit('setUser', userUpdated);

      this.setUser(omit(this.user, ['deleted', 'time_created', 'time_updated', 'logo_url', 'golf_courses', 'user_type',
        'type_id',
      ]));

      this.$i18n.locale = this.user.language;
    },
    onNewPhotoSelected(event) {
      this.G_createUrlFromFile(event, (mImage)=> {
          this.newUserPhoto = mImage;
      });
    },
    
  },
  mounted() {
    if (process.env.VUE_APP_SENTRY_ENV == "production") {
      this.$analytics.setCurrentScreen("Web Settings Profile");
      this.$analytics.logEvent("web_settings_profile");
    }

    if (this.$router.currentRoute.params.id) {
      this.apiGetUser(this.$router.currentRoute.params.id);
    } else {
      this.apiGetMe();
    }
  },
};

</script>
